import React, { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import $ from "jquery";

import { Button, Menu, MenuItem } from "@mui/material";

import "./index.scss";
import "@assets/stylesheets/_header.scss";
import "@assets/stylesheets/app.scss";
import HeaderLogo from "@assets/images/logo.svg";
import { useAppSelector } from "@redux/hooks";
import { Link, useHistory } from "react-router-dom";
import { logout } from "@redux/features/auth/authSlice";

// ! Not being used. Delete or modify later
const lngs: any = {
  en: { nativeName: 'English' },
  no: { nativeName: 'Norwegian' }
};

type NavBarProps = {
  LanguageList?: ReactElement;
};

const NavigationBar: React.FC<NavBarProps> = (props) => {
  const history = useHistory();

  const { t, i18n } = useTranslation();

  const [dropdownAnchorEl, setDropdownAnchorEl] = useState<any>(null);
  const dropdownOpen = Boolean(dropdownAnchorEl);

  const handleDDClick = (event: any) => {
    setDropdownAnchorEl(event.currentTarget);
  };
  const handleDDClose = () => {
    setDropdownAnchorEl(null);
  };

  // ! Not being used. Delete later
  // redux store variables
  const user = useAppSelector((state) => state.auth.user);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  // redux dispatch
  const dispatch = useDispatch();

  // logout function
  const handleLogout = () => {
    console.log("Logout");
    handleDDClose();

    // clear user details from redux
    dispatch(logout())

    history.push("/")
  }

  // existing jQuery listeners and some fixes
  useEffect(() => {
    $(".header-lang__curr").on("click", function () {
      $(this).closest(".header-lang").toggleClass("active");
    });

    $(document).on("click", function () {
      $(".header-lang").removeClass("active");
    });

    $(document).on("click", ".header-lang__curr", function (e) {
      e.stopPropagation();
    });

    $(document).on("click", ".header-lang__list", function (e) {
      e.stopPropagation();
    });

    const touch = $(".mobile-menu__btn");

    const toggles = document.querySelectorAll(".mobile-menu__btn");

    for (let i = toggles.length - 1; i >= 0; i--) {
      const toggle = toggles[i];
      toggleHandler(toggle);
    }

    function toggleHandler(toggle: Element) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        toggle.classList.contains("active") === true
          ? toggle.classList.remove("active")
          : toggle.classList.add("active");
      });
    }

    // * Commenting this function fixed mobile navbar but other issues arise from that
    // * Problem was caused by code duplication.
    $(touch).on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("menu-opened").removeClass("login-menu__show");
      return false;
    });

    $(document).on("click", ".mobile-menu__btn", function (e) {
      e.stopPropagation();
    });

    $(document).on("click", ".mobile-menu__wrapper", function (e) {
      e.stopPropagation();
    });
  }, []);

  return (
    <header className="header">
      <div>
        {/* {Object.keys(lngs).map((lng) => (
            <button key={lng} type="submit" onClick={() => i18n.changeLanguage(lng)}>
              {lngs[lng].nativeName}
            </button>
          ))} */}
      </div>
      <div className="container-lg">
        <div className="header-main max-tablet:px-4">
          <div className="header-left">
            <button className="mobile-menu__btn">
              <span></span>
            </button>
            <ul className="menu">
              {/*<li>*/}
              {/*   <a href="/">*/}
              {/*    {t('navbar.home')}*/}
              {/*  </a> */}
              {/*   <Link to={"/"}>*/}
              {/*    Home*/}
              {/*  </Link> */}
              {/*</li>*/}
              <li>
                <a href="/product">
                  {t('navbar.product')}
                </a>
                {/* <Link to={"/product"}>
                  Product
                </Link> */}
              </li>
              <li>
                <a href="/price">
                  {t('navbar.pricing')}
                </a>
              </li>
              <li>
                <a href="/partners">
                  {t('navbar.partners')}
                </a>
              </li>
              <li>
                <a href="/about">
                  {t('navbar.about_us')}
                </a>
              </li>
            </ul>
          </div>

          {/* //* Removing 'header-logo' class fixed navbar logo issue, 
              //* but removed scroll friendliness */}
          <a href="/" className="header-logo max-tablet:h-[72px]">
            <img className="max-tablet:max-h-[32px]" src={HeaderLogo} alt="" />
          </a>
          <div className="header-right">
            <ul className="menu">
              <li className="d-flex align-items-center">
                <a href="/support">
                  {t('navbar.support')}
                </a>
              </li>
              <li className="d-flex align-items-center">
                <a href="/news">
                  {t('navbar.news')}
                </a>
              </li>
            </ul>

            <div className="header-lang">
              <div className="header-lang__curr">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.093 18.999C9.69731 18.999 9.30166 18.999 8.906 18.999C8.68012 18.9717 8.45425 18.9475 8.22989 18.9156C6.15155 18.6155 4.33546 17.759 2.86046 16.2658C0.403139 13.7782 -0.491261 10.7903 0.256093 7.37335C0.821536 4.79323 2.3026 2.80736 4.54163 1.41422C6.54114 0.16964 8.72712 -0.241178 11.0495 0.133257C12.8702 0.425832 14.471 1.20805 15.8368 2.44505C17.4513 3.90793 18.4655 5.7134 18.849 7.86451C18.9111 8.21014 18.9475 8.56032 18.9945 8.90747C18.9945 9.30313 18.9945 9.69878 18.9945 10.0944C18.9839 10.1414 18.9703 10.1884 18.9627 10.2369C18.8869 10.7236 18.8414 11.2177 18.7307 11.6968C17.8849 15.3471 14.8166 18.232 11.1329 18.8535C10.7888 18.9126 10.4401 18.9505 10.093 18.999ZM4.87059 5.57394C4.88878 5.57697 4.86452 5.56939 4.84027 5.56939C3.96255 5.56939 3.08634 5.56636 2.20861 5.57394C2.15101 5.57394 2.06915 5.63912 2.03883 5.69521C1.722 6.28491 1.48855 6.90947 1.34605 7.56284C1.24751 8.01155 1.18839 8.46785 1.10956 8.93324C2.27077 8.93324 3.37891 8.93324 4.44461 8.93324C4.58711 7.80387 4.72809 6.69118 4.87059 5.57394ZM14.1269 5.56787C14.2694 6.69876 14.4103 7.80993 14.5513 8.93324C15.6246 8.93324 16.7343 8.93324 17.8561 8.93324C17.85 8.82409 17.8485 8.72556 17.8379 8.62854C17.7393 7.72656 17.4907 6.86702 17.139 6.02871C16.9905 5.6755 16.8116 5.53452 16.4099 5.55574C15.6398 5.59819 14.8666 5.56787 14.1269 5.56787ZM8.9348 5.58151C8.90297 5.57545 8.88478 5.56939 8.8681 5.56939C7.97825 5.56939 7.08991 5.5709 6.20006 5.56484C6.08182 5.56484 6.06211 5.62093 6.03937 5.71492C5.8332 6.55019 5.71496 7.39912 5.64826 8.25562C5.63159 8.47997 5.62704 8.70585 5.61643 8.93324C6.73518 8.93324 7.8312 8.93324 8.93632 8.93324C8.9348 7.81448 8.9348 6.70482 8.9348 5.58151ZM13.3734 8.93779C13.378 8.9014 13.3841 8.88321 13.3825 8.86654C13.3371 7.80993 13.2112 6.76394 12.9672 5.73311C12.9338 5.59061 12.8717 5.56484 12.7428 5.56636C11.9091 5.5709 11.0753 5.56939 10.2415 5.56939C10.1824 5.56939 10.1233 5.57394 10.0702 5.57697C10.0702 6.70937 10.0702 7.82358 10.0702 8.9393C11.1753 8.93779 12.2683 8.93779 13.3734 8.93779ZM1.14595 10.0656C1.14595 10.1096 1.14443 10.1354 1.14595 10.1596C1.22326 11.2647 1.52493 12.3062 2.02822 13.29C2.05702 13.3461 2.1601 13.3916 2.22984 13.3931C2.85288 13.4007 3.47745 13.3977 4.1005 13.3977C4.36578 13.3977 4.62956 13.3977 4.86149 13.3977C4.72203 12.2819 4.58408 11.1783 4.44461 10.0672C3.36982 10.0656 2.26622 10.0656 1.14595 10.0656ZM17.894 10.0672C16.7297 10.0672 15.6216 10.0672 14.5513 10.0672C14.4103 11.1844 14.2724 12.2865 14.1329 13.3961C15.0197 13.3961 15.9278 13.3977 16.8343 13.3901C16.8859 13.3901 16.9617 13.3173 16.9829 13.2627C17.2012 12.6943 17.4437 12.1319 17.6135 11.5482C17.7545 11.0752 17.803 10.575 17.894 10.0672ZM5.61491 10.0626C5.65433 11.198 5.78773 12.3016 6.06514 13.3855C7.02927 13.3855 7.97825 13.3855 8.93025 13.3855C8.93025 12.2728 8.93025 11.1708 8.93025 10.0626C7.82514 10.0626 6.73215 10.0626 5.61491 10.0626ZM12.9338 13.3901C13.2067 12.288 13.3507 11.1874 13.381 10.0702C12.2608 10.0702 11.1632 10.0702 10.0702 10.0702C10.0702 11.1844 10.0702 12.288 10.0702 13.3901C11.0283 13.3901 11.9727 13.3901 12.9338 13.3901ZM8.93025 17.7787C8.93025 16.6766 8.93025 15.5988 8.93025 14.5225C8.08739 14.5225 7.25818 14.5225 6.40471 14.5225C6.80946 15.5745 7.27789 16.5599 8.12984 17.3103C8.36026 17.5149 8.61797 17.6817 8.93025 17.7787ZM10.0611 17.7635C11.0495 17.5377 12.1319 15.9581 12.567 14.5255C11.7317 14.5255 10.8964 14.5255 10.0611 14.5255C10.0611 15.6139 10.0611 16.6872 10.0611 17.7635ZM8.9348 4.4476C8.9348 3.37129 8.9348 2.30559 8.9348 1.19289C7.52347 1.85839 6.95954 3.13177 6.40774 4.4476C7.26273 4.4476 8.08891 4.4476 8.9348 4.4476ZM12.6018 4.44608C12.4108 4.03072 12.2471 3.63354 12.0485 3.25153C11.7135 2.60574 11.3072 2.00846 10.713 1.57036C10.5189 1.42635 10.2976 1.32175 10.0642 1.18531C10.0642 2.30559 10.0642 3.37129 10.0642 4.44608C10.8994 4.44608 11.7241 4.44608 12.6018 4.44608ZM16.2173 14.5104C15.4381 14.5104 14.7029 14.5164 13.9692 14.5058C13.8116 14.5043 13.7479 14.5558 13.7009 14.6998C13.3932 15.6306 12.9763 16.5068 12.3926 17.2997C12.382 17.3148 12.376 17.3345 12.3517 17.3861C13.9268 16.7933 15.1926 15.8519 16.2173 14.5104ZM6.623 17.3558C6.02118 16.5174 5.58914 15.6003 5.27079 14.6271C5.23593 14.5194 5.17529 14.5073 5.07979 14.5073C4.36275 14.5103 3.64723 14.5088 2.9302 14.5088C2.89078 14.5088 2.85288 14.5164 2.78921 14.524C3.80792 15.8519 5.07221 16.7949 6.623 17.3558ZM12.382 1.62797C12.6443 2.0782 12.9217 2.50417 13.1445 2.95592C13.3674 3.40918 13.5311 3.88974 13.7312 4.35361C13.7524 4.40364 13.8494 4.45063 13.9101 4.45063C14.6211 4.45669 15.332 4.45518 16.0415 4.45366C16.0794 4.45366 16.1188 4.44305 16.1764 4.43547C15.1668 3.13177 13.9116 2.20099 12.382 1.62797ZM6.623 1.64616C5.08888 2.20099 3.83066 3.13025 2.83318 4.42486C2.85895 4.44153 2.86804 4.45215 2.87865 4.45215C3.63207 4.45366 4.38701 4.45669 5.14042 4.45063C5.18742 4.45063 5.25867 4.38999 5.27534 4.343C5.60278 3.38645 6.02573 2.47689 6.623 1.64616Z"
                    fill="url(#paint0_linear_140_6)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_140_6"
                      x1="-1.24579e-08"
                      y1="8.36654"
                      x2="19.0089"
                      y2="8.66076"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#8850F4" />
                      <stop offset="1" stopColor="#6959FC" />
                    </linearGradient>
                  </defs>
                </svg>
                <span>
                  {/* Show current language */}
                  {i18n.language === "en-GB" ? "En" : i18n.language}
                </span>
              </div>
              <div className="header-lang__list w-[160px] max-h-[254px]">
                <ul>
                  <li className="border-4 border-black rounded-lg">
                    {/* <a href="javascript:void(0)">En</a> */}
                    <a className="font-light leading-[24px] font-[16px] m-[8px] hover:bg-[#F3F2EF]" style={{ height: "48px" }} onClick={() => i18n.changeLanguage('en')}>English</a>
                  </li>
                  <li className="border-4 border-black rounded-lg">
                    <a className="font-light leading-[24px] font-[16px] m-[8px] hover:bg-[#F3F2EF]" style={{ height: "48px" }} onClick={() => i18n.changeLanguage('no')}>Norwegian</a>
                  </li>
                </ul>
              </div>
            </div>

            {!isAuthenticated ?
                <>
                  <Link
                      to={"/login"}
                      className="text-base ml-8 hover:text-[#B1B2E1] active:text-[#907DE4] font-semibold"
                  >
                    {t('loginPage.logInBtn')}
                  </Link>
                  <Link
                      className="header-login btn btn-filled px-3 bg-inherit h-[52px] w-[118px] font-semibold text-[16px] font-[600] leading-[24px]"
                      to={"/registration"}
                  >
                    <span>
                      {t('loginPage.registerBtn')}
                    </span>

                  </Link>
                </>
                 :
                ""}

            {/* Show logged in feedback if logged in and not loading */}
            {
              isAuthenticated &&
              (
                // <div>
                //   <p className="text-small">
                //     <a href="/dashboard/main">Dashboard</a>
                //   </p>
                //   <p className="text-small">
                //     <a 
                //       href=""
                //       onClick={logout}
                //     >
                //       Logout.
                //     </a>
                //   </p>
                // </div>
                <div className="header-login">
                  <Button
                    id="profile-btn"
                    className="customNavDropDown d-flex align-items-center"
                    onClick={handleDDClick}
                    style={{ fontSize: '0.9rem' }}
                  >
                    <span className="text-sm-semibold"> {
                      user?.first_name ?? user?.email ?? "-"
                    }</span>
                  </Button>

                  <Menu
                    id="profile-menu"
                    anchorEl={dropdownAnchorEl}
                    open={dropdownOpen}
                    disableScrollLock={true}
                    onClose={handleDDClose}
                  >
                    <MenuItem>
                      <Link to="/dashboard/main">
                        Dashboard
                      </Link>
                    </MenuItem>
                    <MenuItem>
                      <a onClick={handleLogout}>
                        Logout
                      </a>
                    </MenuItem>
                  </Menu>

                </div>
              )
            }
          </div>
          <div className="mobile-menu__wrapper">
            <ul className="mobile-menu">
              <li>
                <a href="/">
                  {t('navbar.home')}
                </a>
              </li>
              <li>
                <a href="/product">
                  {t('navbar.product')}
                </a>
              </li>
              <li>
                <a href="/price">
                  {t('navbar.pricing')}
                </a>
              </li>
              <li>
                <a href="/partners">
                  {t('navbar.partners')}
                </a>
              </li>
              <li>
                <a href="/about">
                  {t('navbar.about_us')}
                </a>
              </li>
              <li>
                <a href="/support">
                  {t('navbar.support')}
                </a>
              </li>
              <li>
                <a href="/news">
                  {t('navbar.news')}
                </a>
              </li>
            </ul>
            <a href="/login" className="btn btn-filled">
              {t('navbar.login')}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default NavigationBar;
